import { useTranslation } from "react-i18next";
import { Modal } from "../../common";
import { Button } from "../../App.styles";

const SearchAndAddModal = ({ onDismiss, show }) => {
  const { t } = useTranslation();

  return (
    <Modal onDismiss={onDismiss} show={show}>
      <div className="modal-header">
        <h4 className="modal-title">{t('Search and Add')}</h4>
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-hidden="true"
          onClick={onDismiss}
        >
          ×
        </button>
      </div>
      <div className="modal-body">
        <p>
          {t(`The library is a curated selection of the best challenges. Simply
          search, select and tap add. Once added, go back to your challenges
          editor to customize it.`)}
        </p>
        <ul>
          <li>
            {t(`The library is updated continously. Search results will change over
            time.`)}
          </li>
          <li dangerouslySetInnerHTML={{__html: t("Unable to find what you're looking for? Talk to us.")}} />
          <li>{t('Want to save a search? Grab the URL and use it again later.')}</li>
        </ul>
      </div>
      <div className="modal-footer">
        <Button color="dark" data-dismiss="modal" onClick={onDismiss}>
          {t('Close')}
        </Button>
      </div>
    </Modal>
  )
};

export default SearchAndAddModal;
